export const getUnreadStatus = (
  conversationId: number,
  unreadList: number[]
): boolean => {
  return (unreadList || []).includes(conversationId)
}
